"use client"

import { useEffect } from "react"
import { initViewportHeight } from "@/lib/viewport"
import { debugLog } from "@/lib/debug"
import { applyErudaPreference } from "@/lib/eruda-console"

/**
 * 📱 Компонент для инициализации viewport height
 * Исправляет проблемы с мобильными браузерами (особенно Safari)
 */
export function ViewportInitializer() {
  useEffect(() => {
    // Eruda: в development включается сама, пока её явно не выключили (enable_eruda=0).
    try {
      applyErudaPreference()
    } catch {}

    // Помечаем Android-устройства классом на <html> — используется в globals.css
    // для применения Android-специфичных фиксов скролла (overscroll-behavior: contain),
    // которые на iOS ломают нативный scroll chaining (передачу скролла родителю).
    if (/android/i.test(navigator.userAgent)) {
      document.documentElement.classList.add('platform-android')
    }

    debugLog('performance', '📱 [ViewportInitializer] Инициализация viewport height...')
    
    const cleanup = initViewportHeight((height) => {
      debugLog('performance', '📱 [ViewportInitializer] Высота viewport изменилась:', height + 'px')
    })
    
    // Дополнительная проверка через небольшую задержку
    const timer = setTimeout(() => {
      if (typeof window !== 'undefined') {
        const vh = window.innerHeight
        document.documentElement.style.setProperty('--vh', `${vh}px`)
        document.documentElement.style.setProperty('--real-100vh', `${vh}px`)
        debugLog('performance', '📱 [ViewportInitializer] Дополнительная проверка:', vh + 'px')
      }
    }, 500)
    
    return () => {
      cleanup()
      clearTimeout(timer)
    }
  }, [])

  // Компонент не рендерит ничего видимого
  return null
}
